import { TreeItem, ItemType } from './item';
import { DataLink } from '../../data-link/data-link';
import { DossierTree } from './tree';



export class DataItem extends TreeItem {

  link: DataLink;

  constructor(link: DataLink, parent: TreeItem, tree: DossierTree) {
    super(parent, tree);
    this.link = link;
  }

  get type(): ItemType {
    return 'DATA';
  }

  get label(): string {
    return this.link.label;
  }

  get isNew(): boolean {
    return !this.link.id;
  }
}